import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const SearchLinks = ({clang}) => {
    return (
        <div className="search-bar__links">
            <Link className="search-bar__links-advanced" to={`/advanced-search`} title={lang[clang].search.advanced}>
                {lang[clang].search.advanced}
                <span className="search-bar__links-advanced__icon"></span>
            </Link>
            <Link className="search-bar__links-how" to={`/about/how-search`} title={lang[clang].search.how}>
                {lang[clang].search.how}
                <span className="search-bar__links-how__icon"></span>
            </Link>
        </div>
    );
};

SearchLinks.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SearchLinks);



// WEBPACK FOOTER //
// ./src/components/search/SearchLinks.js